module.exports = __webpack_public_path__ + "d47289708e6d598a04d595b92615ceee.svg";